exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".description--smallText--3qZJ0ls_ {\r\n  font-size: 14px;\r\n  color: #0072CE;\r\n  font-weight: 600;\r\n}\r\n\r\n.description--smallSubText--3eaEI8UG {\r\n  font-size: 14px;\r\n  color: #5B6770;\r\n  font-weight: 600;\r\n}\r\n\r\n.description--textBackground--3bDUD2XA {\r\n  background-color: #F6F8F8;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/descriptionEditor/description.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;;AAED;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;;AAED;EACE,0BAA0B;CAC3B","file":"description.css","sourcesContent":[".smallText {\r\n  font-size: 14px;\r\n  color: #0072CE;\r\n  font-weight: 600;\r\n}\r\n\r\n.smallSubText {\r\n  font-size: 14px;\r\n  color: #5B6770;\r\n  font-weight: 600;\r\n}\r\n\r\n.textBackground {\r\n  background-color: #F6F8F8;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"smallText": "description--smallText--3qZJ0ls_",
	"smallSubText": "description--smallSubText--3eaEI8UG",
	"textBackground": "description--textBackground--3bDUD2XA"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/descriptionEditor/description.css
// module id = 406
// module chunks = 0